<h5 translate>Hide ticket content</h5>
<hr />
<form appCheckFormInit #hideTextForm="ngForm">
    <div class="form-group">
        <label for="hiding-text" translate class="fw-bold">Text for hiding</label>
        <p translate>Enter the string of text you want to hide from customer</p>
        <input
            type="text"
            class="form-control"
            id="hiding-text"
            appFocus
            [appAutoFocus]="true"
            name="hidingText"
            autocomplete="off"
            [(ngModel)]="hidingText"
            [disabled]="isWholeContentHidden" />
    </div>

    <div class="form-group">
        <label class="checkbox__label checkbox__label--size-small" for="isWholeContentHidden">
            {{ 'Hide whole reply content' | translate }}
            <input
                type="checkbox"
                id="isWholeContentHidden"
                name="isWholeContentHidden"
                [(ngModel)]="isWholeContentHidden" />
            <span class="checkbox__checkmark"></span>
        </label>
    </div>

    <div class="buttons-row">
        <button type="button" class="btn btn-default" (click)="closePanel()" translate>Cancel</button>
        <button
            type="button"
            class="btn btn-primary ms-2"
            (click)="save()"
            [disabled]="isSaving || (!isWholeContentHidden && !hidingText)"
            translate>
            Hide
        </button>
    </div>
</form>
